import { INeo4j } from "../interfaces/Neo4j";
import { ViewFromServer } from "../interfaces/ViewFromServer";

export class Exporter {
    constructor(public connection: INeo4j, public view?: ViewFromServer){}
}